import httpService from './httpService'
import SessionService from './sessionService'

async function add(organizationId, data) {
  return httpService.apiRequest('post', `/profile/${SessionService.getUserUsername()}/organization/${organizationId}/device`, data)
}

async function update(organizationId, serialNo, data) {
  return httpService.apiRequest('patch', `/profile/${SessionService.getUserUsername()}/organization/${organizationId}/device/`, data)
}

async function remove(organizationId, serialNo) {
  return httpService.apiRequest('delete', `/profile/${SessionService.getUserUsername()}/organization/${organizationId}/device/`)
}

async function checkMac(serialNo) {
  return httpService.apiRequest('delete', `/profile/${SessionService.getUserUsername()}/device/${serialNo}/checkMac`)
}

export default {
  add,
  update,
  remove,
  checkMac
}



// WEBPACK FOOTER //
// ./src/services/deviceService.js